module.exports = __webpack_public_path__ + "assets/pdf/01.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/01.pdf
// module id = y0QA
// module chunks = 1